module.exports = __webpack_public_path__ + "img/z- (6)_Moment.d3daab1b.jpg";